import { ProgressCircular } from '@sky-distribution/react-commons-ui';
import { LoaderSection } from './CircularLoader.styles';

export const CircularLoader = () => (
  <LoaderSection>
    <ProgressCircular />
  </LoaderSection>

);
